<template>
    <v-row>
        <v-col sm="12">
            <v-card>
                <v-card-title>
                    <!--<v-icon @click="pushRouteToView('persons')" class="mr-4" style="cursor: pointer">
                        mdi-arrow-left
                    </v-icon>-->
                    <v-btn
                        small
                        @click="pushRouteToView('persons')"
                        class="mr-4 btn-back"
                    >
                        <v-icon> mdi-arrow-left </v-icon>
                        Voltar
                    </v-btn>
                    <v-icon left>mdi-account-box-multiple</v-icon>
                    Dados do Cliente
                    <v-spacer></v-spacer>
                    
<!--                    <v-btn outlined class="btn-del"-->
<!--                           @click="dialogDeletePerson=true">-->
<!--                        <v-icon left>mdi-delete</v-icon>-->
<!--                        Excluir-->
<!--                    </v-btn>-->

<!--                    <v-btn outlined-->
<!--                           :class="`${person.active? 'btn-inactive': 'btn-active'} mx-2`"-->
<!--                           @click="dialogActiveInactive=true">-->
<!--                        <v-icon left>mdi-pencil</v-icon>-->
<!--                        <span v-if="person.active">Inativar</span><span v-else>Ativar</span>-->
<!--                    </v-btn>-->

                    <v-btn
                        :to="{ name: 'personsEdit', params: { id: person.id } }"
                        class="btn-edit"
                    >
                        <v-icon left>mdi-pencil</v-icon>
                        Editar
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="text-data-visualization">
                         <v-card style="border-left: solid 10px #3D1159 !important;">
                                <v-card-title>

                                </v-card-title>

                                <v-card-text class="text-data-visualization">
                    <v-row>
                        <v-col md="6" sm="12" xl="6">
                            <b><v-icon>mdi-account</v-icon> Nome:</b> {{ person.name }}
                        </v-col>
                        <v-col md="6" sm="12" xl="6">
                            <b><v-icon>mdi-card-account-details-outline</v-icon> CPF:</b> {{ person.cpf}}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col md="6" sm="12" xl="6">
                            <b><v-icon>mdi-phone</v-icon> Telefone:</b> {{ person.phone }}
                        </v-col>
                        <v-col md="6" sm="12" xl="6">
                            <b><v-icon>mdi-calendar-range</v-icon> Data de Nascimento:</b> {{ person.birthdate }}
                        </v-col>
                        <!--<v-col md="4" sm="6" xs="12">
                            <b>Status:</b> {{ person.active | activeText }}
                        </v-col>-->
                    </v-row>
                                </v-card-text>
                         </v-card> 
                   

                </v-card-text>
                <v-alert type="warning" outlined v-show="!person"
                >Nenhum cliente encontrado
                </v-alert
                >
<!--                <confirm-dialog-->
<!--                    :dialog="dialogActiveInactive"-->
<!--                    :title="`${person.active? 'Inativar ': 'Ativar '} ${person.name}`"-->
<!--                    body="Tem certeza que deseja realizar essa ação?"-->
<!--                    @dialog-event="inactiveActive">-->
<!--                </confirm-dialog>-->
<!--                <confirm-dialog-->
<!--                    :dialog="dialogDeletePerson"-->
<!--                    :title="`Excluir  ${person.name}`"-->
<!--                    :body="`Tem certeza que deseja excluir o/a cliente ${person.name} ?`"-->
<!--                    @dialog-event="deletePerson">-->
<!--                </confirm-dialog>-->

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {mask} from "vue-the-mask";

import {
    PERSON_GET,
} from "@/store/actions/person.type";
import { PERSON_RESET_STATE} from "@/store/mutations/person.type";

export default {
    name: "person",
    directives: {mask},
    props: {
        id: {
            default: 0,
            type: Number,
            required: true
        }
    },

    components: {},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.commit(PERSON_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        Promise.all([
            await store.commit(PERSON_RESET_STATE),
            await store.dispatch(PERSON_GET, to.params.id)
        ]).then(() => {
            next();
        });
    },
    data: () => ({
        //Lista de Usuários
        pagination: {
            sortBy: "name"
        },
        search: "",
        selected: [],
        formIsValid: false,

        dialogActiveInactive:false,
        dialogDeletePerson:false
    }),
    methods: {
        pushRouteToView(route) {
            this.$router.push({name: route});
        },
        
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },
        // deletePerson(status){
        //     this.dialogDeletePerson=false
        //     if(!status){
        //         return
        //     }
        //     this.$store.commit(CHANGE_PROGRESS, true)
        //     this.$store
        //         .dispatch(PERSON_DELETE)
        //         .then(() => {
        //
        //             this.$store.commit(CHANGE_PROGRESS, false)
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "success";
        //             this.snackbar.text = "Excluído com sucesso";
        //
        //             this.$router.push({
        //                 name: "persons",
        //             });
        //         })
        //         .catch(({response}) => {
        //             this.$store.commit(CHANGE_PROGRESS, false)
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "error";
        //             this.snackbar.text = "Erro ao excluir.";
        //             // console.log(response.data);
        //             if (typeof response.data.message !== "undefined") {
        //                 this.snackbar.text = response.data.message;
        //             }
        //         });
        // },
        // inactiveActive(status) {
        //     this.dialogActiveInactive=false
        //     if(!status){
        //         return
        //     }
        //     let action = this.person.active ? PERSON_INACTIVE : PERSON_ACTIVE;
        //     this.$store.commit(CHANGE_PROGRESS, true)
        //
        //     this.$store
        //         .dispatch(action, this.person.id)
        //         .then(() => {
        //
        //             this.$store.commit(CHANGE_PROGRESS, false)
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "success";
        //             this.snackbar.text = "Alterado com sucesso";
        //             this.$store.commit(SET_PERSON_ACTIVE, !this.person.active)
        //         })
        //         .catch(({response}) => {
        //             this.$store.commit(CHANGE_PROGRESS, false)
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "error";
        //             this.snackbar.text = "Erro ao alterar.";
        //             // console.log(response.data);
        //             if (typeof response.data.message !== "undefined") {
        //                 this.snackbar.text = response.data.message;
        //             }
        //         });
        // }
    },
    mounted() {
    },
    computed: {
        ...mapGetters(["snackbar", "inProgress", "checkUsers", "person"])
    },
    watch: {}
};
</script>
